module.exports = "<div class=\"container-fullscreen\">\n    <app-building-customization [params]=[params]></app-building-customization>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/full-screen/full-screen.component.html
// module id = ./src/app/full-screen/full-screen.component.html
// module chunks = main